import { Checkbox, Flex, Group, Text, rem } from "@mantine/core";
import UserAvatar from "./UserAvatar";
import { UserFields } from "../types/user.types";
import { useState } from "react";

import classes from './CheckboxButton.module.css';

interface UserCheckboxCardProps {
  user: UserFields;
  checked?: boolean;
  onCheck?: Function;
}

export default function UserCheckboxCard(
  { user, onCheck, checked = false }: UserCheckboxCardProps
) {
  const [isChecked, setIsChecked] = useState(checked);

  const handleOnClick = () => {
    const c = !isChecked;
    setIsChecked(c);
    onCheck && onCheck(user, c);
  };

  return (
    <Checkbox.Card
      className={classes.root}
      p="xs"
      withBorder
      checked={isChecked}
      onClick={handleOnClick}
    >
      <Group wrap="nowrap" align="center">
        <Checkbox.Indicator />
        <Flex align="center" gap="sm">
          <UserAvatar user={user} />
          <Text size={rem(15)}>
            {user.name ? user.name : user.username}
          </Text>
        </Flex>
      </Group>
    </Checkbox.Card>
  );
}
